export default function ToolForm($) {
    const MAX_SIZE_PX = 2500;
    const MAX_FILE_MB = 15;
    const QUALITY = 0.8;

    const state = {
        blobs: {}
    };

    const $form = $('#form-tool-scan');
    const $btnSubmit = $('#btn-submit');

    function checkSubmitReady() {
        const ready = state.blobs[1] && state.blobs[2];
        $btnSubmit.prop('disabled', !ready);
    }

    function resizeImage(file) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const url = URL.createObjectURL(file);

            img.onload = function () {
                URL.revokeObjectURL(url);

                let w = img.naturalWidth;
                let h = img.naturalHeight;

                if (w > MAX_SIZE_PX || h > MAX_SIZE_PX) {
                    if (w >= h) {
                        h = Math.round(h * MAX_SIZE_PX / w);
                        w = MAX_SIZE_PX;
                    } else {
                        w = Math.round(w * MAX_SIZE_PX / h);
                        h = MAX_SIZE_PX;
                    }
                }

                const canvas = document.createElement('canvas');
                canvas.width = w;
                canvas.height = h;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, w, h);

                canvas.toBlob(blob => {
                    if (!blob) return reject(new Error('Canvas conversion failed'));

                    const reader = new FileReader();
                    reader.onload = e => resolve({
                        dataUrl: e.target.result,
                        blob
                    });

                    reader.readAsDataURL(blob);

                }, 'image/jpeg', QUALITY);
            };

            img.onerror = () => {
                URL.revokeObjectURL(url);
                reject(new Error('Imaginea nu a putut fi citită.'));
            };

            img.src = url;
        });
    }

    $('.photo-input').on('change', async function () {
        const slot = parseInt($(this).data('slot'), 10);
        const file = this.files[0];
        if (!file) return;

        const $status = $('#status-' + slot);
        const $previewImg = $('#preview-img-' + slot);
        const $placeholder = $('#preview-placeholder-' + slot);
        const $overlay = $('#overlay-' + slot);

        if (!file.type.startsWith('image/')) {
            $status.text('Fișier invalid (nu este imagine).');
            return;
        }

        if (file.size > MAX_FILE_MB * 1024 * 1024) {
            $status.text(`Fișier prea mare (max ${MAX_FILE_MB}MB).`);
            return;
        }

        $status.text('Se procesează...');

        try {
            const { dataUrl, blob } = await resizeImage(file);

            state.blobs[slot] = blob;

            $previewImg.attr('src', dataUrl).removeClass('hidden');
            $placeholder.addClass('hidden');
            $overlay.removeClass('hidden');

            $status.text(`✓ ${(blob.size / 1024).toFixed(0)} KB`);

            checkSubmitReady();
        } catch (err) {
            $status.text(err.message);
        }
    });

    $(document).on('click', '.btn-retake', function (e) {
        e.preventDefault();

        const targetId = $(this).data('target');
        const $input = $('#' + targetId);
        const slot = parseInt($input.data('slot'), 10);

        $input.val('');

        state.blobs[slot] = null;

        checkSubmitReady();
    });

    $form.on('submit', async function (e) {
        e.preventDefault();

        if ($btnSubmit.hasClass('loading')) return;

        if (!ESR.Helper.userCan('create_tool_assignment')) {
            throw new Error('Utilizatorul nu are permisiunile necesare.');
        }

        if (!state.blobs[1] || !state.blobs[2]) {
            throw new Error('Trebuie să adaugi minim 2 fotografii.');
        }

        $btnSubmit.prop('disabled', true).addClass('loading');

        try {
            const toolId = $form.find('[name="tool_id"]').val();

            const slots = Object.keys(state.blobs).filter(k => state.blobs[k]);
            const files  = slots.map(slot => `${slot}.jpg`);

            const presignResp = await $.ajax({
                type: 'POST',
                url:  ESR.ajaxurl,
                data: {
                    action:    'esr_get_s3_urls',
                    security:  ESR.nonce,
                    object_id: toolId,
                    folder:    'tools',
                    files:     JSON.stringify(files)
                }
            });

            if (!presignResp.success) {
                throw new Error('Eroare la generarea linkurilor S3.');
            }

            await Promise.all( presignResp.data.map((p, i) => uploadToS3(p.url, state.blobs[slots[i]])));

            const imageKeys = presignResp.data.map(p => p.key);
            const comment   = $('#scan-comment').val().trim();

            const response = await $.ajax({
                type: 'POST',
                url:  ESR.ajaxurl,
                data: {
                    action:      'esr_add_tool_assignment',
                    security:    ESR.nonce,
                    tool_id:     toolId,
                    s3_img_keys: imageKeys.join(','),
                    comment
                }
            });

            if(response.success){
                ESR.Popup.success({
                    text:             response.data.message,
                    cancelButtonText: 'Închide',
                    cancelButtonUrl:  'reload',
                    closeButtonUrl:   'reload'
                });
            }else{
                console.log(response)
                throw new Error(response.data.message || 'Eroare la salvarea datelor.');
            }

        } catch (err) {
            ESR.Popup.error({
                text:            err.message || 'Eroare necunoscută.',
                cancelButtonText: 'Închide',
                cancelButtonUrl:  'reload',
                closeButtonUrl:   'reload'
            });
        } finally {
            $btnSubmit.removeClass('loading').prop('disabled', false);
        }
    });

    function uploadToS3(url, blob) {
        return $.ajax({
            type: 'PUT',
            url,
            data: blob,
            processData: false,
            contentType: blob.type || 'image/jpeg'
        });
    }
}